import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';

import { UI } from 'src/features/transfer/constants';
import NewHeader from 'src/layouts/new-header/NewHeader';
import NewFooter from 'src/layouts/new-footer/NewFooter';
import Hero from 'src/features/transfer/sections/Hero';
import StepsSection from 'src/features/transfer/sections/StepsSection';
import FeesSection from 'src/features/transfer/sections/FeesSection';
import FaqSection from 'src/features/transfer/sections/FaqSection';
import FinalCta from 'src/features/transfer/sections/FinalCta';
import CalculatorDialog from 'src/features/transfer/components/CalculatorDialog';
import CalculatorButton, {
  CALCULATOR_HASH,
} from 'src/features/transfer/components/CalculatorButton';

export default function NewDesign() {
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();

  // #calculator opens the dialog (button, header link, or a shared URL).
  // Back button on mobile closes it, because opening pushes a history entry.
  const calculatorOpen = hash === CALCULATOR_HASH;

  useEffect(() => {
    if (!hash) return;
    if (hash === CALCULATOR_HASH) return;
    const el = document.querySelector(hash);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hash]);

  const handleCloseCalculator = () => {
    navigate({ pathname, search }, { replace: true });
  };

  return (
    <>
      <Helmet>
        <title>SafiSwap | Crypto in, cash in Somalia out</title>
      </Helmet>

      <Box
        sx={{
          bgcolor: UI.bg,
          color: UI.text,
          minHeight: '100vh',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -200,
            left: -160,
            width: 1000,
            height: 1000,
            background: `radial-gradient(circle, ${UI.green}22 0%, transparent 60%)`,
            pointerEvents: 'none',
            zIndex: 0,
          },
          '& > *': {
            position: 'relative',
            zIndex: 1,
          },
        }}
      >
        <NewHeader />
        <Hero />
        <CalculatorButton variant="banner" />
        <StepsSection />
        <FeesSection />
        <FaqSection />
        <FinalCta />
        <NewFooter />
      </Box>

      <CalculatorDialog open={calculatorOpen} onClose={handleCloseCalculator} />
    </>
  );
}
